export const graidentTextStyle = {
  background: "linear-gradient(90.48deg, #435b8c 8.97%, #D4E4FC 53.35%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
};
